import React from 'react';
import { Typography, Progress, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface CPPDTaskCardProps {
  titulo: string;
  percentual: number;
  respostasObtidas: number;
  planosAcaoIniciados: number;
}

export const CPPDTaskCard: React.FC<CPPDTaskCardProps> = ({
  titulo,
  percentual,
  respostasObtidas,
  planosAcaoIniciados
}) => {
  const getStrokeColor = () => {
    return {
      '0%': '#7839EE',
      '100%': '#2ECEF7'
    };
  };

  const getTextoEstatico = (titulo: string) => {
    switch (titulo.toLowerCase()) {
      case 'pendentes':
        return 'Pendentes';
      case 'em andamento':
        return 'Em Andamento';
      case 'concluído':
      case 'concluido':
        return 'Concluído';
      default:
        return 'Concluído';
    }
  };

  return (
    <div style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px' 
    }}>
      {/* Gráfico circular */}
      <div style={{ 
        width: '160px', 
        height: '160px', 
        position: 'relative', 
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'center' 
      }}>
        <Progress
          type="circle"
          percent={Math.round(percentual)}
          width={150}
          strokeWidth={12}
          strokeColor={getStrokeColor()}
          trailColor="#E4E7EC"
          format={() => (
            <div style={{ 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              padding: '0 10px'
            }}>
              <div style={{ 
                fontSize: '32px', 
                fontWeight: 'bold', 
                color: '#344054',
                lineHeight: '1',
                marginBottom: '8px'
              }}>
                {Math.round(percentual)}%
              </div>
              
              <div style={{ 
                fontSize: '13px', 
                color: '#667085',
                fontWeight: 500,
                textAlign: 'center',
                lineHeight: '1.2',
                maxWidth: '90px',
                wordWrap: 'break-word'
              }}>
                {getTextoEstatico(titulo)}
              </div>
            </div>
          )}
        />
      </div>
      
      {/* Estatísticas em linha única */}
      <div style={{ width: '100%', marginTop: '10px' }}>
        {/* Respostas obtidas */}
        <div style={{ 
          marginBottom: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ 
              width: '12px', 
              height: '12px', 
              backgroundColor: '#7839EE', 
              borderRadius: '2px',
              marginRight: '8px'
            }}></div>
            <Text style={{ color: '#667085', fontSize: '12px' }}>
              Respostas obtidas
              <Tooltip title="Total de respostas recebidas para esta tarefa">
                <InfoCircleOutlined style={{ marginLeft: 6, fontSize: '12px', color: '#98A2B3' }} />
              </Tooltip>
            </Text>
          </div>
          {/* Valor na mesma linha */}
          <Text strong style={{ 
            fontSize: '18px', 
            color: '#344054',
            fontWeight: 600
          }}>
            {Math.round(respostasObtidas)}
          </Text>
        </div>
        
        {/* Planos de ação iniciados */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ 
              width: '12px', 
              height: '12px', 
              backgroundColor: '#2ECEF7', 
              borderRadius: '2px',
              marginRight: '8px'
            }}></div>
            <Text style={{ color: '#667085', fontSize: '12px' }}>
              Planos de ação iniciados
              <Tooltip title="Quantidade de planos de ação que foram iniciados">
                <InfoCircleOutlined style={{ marginLeft: 6, fontSize: '12px', color: '#98A2B3' }} />
              </Tooltip>
            </Text>
          </div>
          {/* Valor na mesma linha */}
          <Text strong style={{ 
            fontSize: '18px', 
            color: '#344054',
            fontWeight: 600
          }}>
            {Math.round(planosAcaoIniciados)}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CPPDTaskCard;